import { render } from "./LeftAddUsersRecently.vue?vue&type=template&id=226956c0"
import script from "./LeftAddUsersRecently.vue?vue&type=script&lang=js"
export * from "./LeftAddUsersRecently.vue?vue&type=script&lang=js"
script.render = render

export default script